import {
	Label as RACLabel,
	LabelProps as RACLabelProps,
} from "react-aria-components";
import clsMerge from "../../util/clsMerge";
import {FCWithHTMLAttributes} from "../../types/reactTypes";

export type LabelClasses = {
	root?: string;
	text?: string;
	requiredDecorator?: string;
	optionalDecorator?: string;
};

type LabelProps = {
	classes?: LabelClasses;
	isDisabled?: boolean;
	isRequired?: boolean;
	hideDecorators?: boolean;
} & Omit<RACLabelProps, "className">;

/**
 * A label that supports error states through react-aria-components.
 * https://react-spectrum.adobe.com/react-spectrum/forms.html#labels-and-help-text
 */
const Label: FCWithHTMLAttributes<LabelProps> = ({
	children,
	classes,
	isDisabled,
	isRequired,
	hideDecorators,
	...props
}) => {
	return (
		<RACLabel className={classes?.root} {...props}>
			<span
				className={clsMerge(
					"title-h6 pb-1",
					isDisabled && "text-gray-700",
					classes?.text
				)}
			>
				{children}
			</span>
			{!hideDecorators &&
				(isRequired ? (
					<span
						className={clsMerge("text-rich-orange", classes?.requiredDecorator)}
					>
						*
					</span>
				) : (
					<span
						className={clsMerge(
							"italic text-gray-500",
							classes?.optionalDecorator
						)}
					>
						{" "}
						Optional
					</span>
				))}
		</RACLabel>
	);
};

export default Label;
